import PropTypes from 'prop-types';
import {renderMarkdown} from 'helpers/text-helper';
import {gameUiTexts} from 'data/ui-texts';
import Button from 'components/ui/button/button';
import './task-intro.scss';

const TaskIntro = (
	{
		showNumberOfAnswersToSelect, 
		numberOfCorrectAnswers, 
		text, 
		image, 
		files, 
		schoolData,
		setPopupFileData, 
		scenarioId
	}) => {
	const showRequiredNumberOfAnswers = (
		showNumberOfAnswersToSelect && 
		numberOfCorrectAnswers && 
		(numberOfCorrectAnswers > 0) ? true : false
	);

	let customText = text ? text : '';
	if (schoolData && schoolData.name) {
		customText = text.replaceAll('%school%', schoolData.name);
	}

	return (
		<div className={'TaskIntro' + (image ? ' ' + image : '')}>
			<div className="TaskIntro-text">
				{customText && renderMarkdown(customText)}
				{files && <div className="TaskIntro-files">
					{files.map((file, index) => {
						return (
							<Button 
								key={index}
								text={file.btnText}
								classes={['login', scenarioId]}
								onClick={() => {setPopupFileData({type: file.type, fileId: file.id});}}
							/>
						);
					})}
				</div>}
				{showRequiredNumberOfAnswers && 
					<div className="TaskIntro-requiredAnswers">{gameUiTexts.choose} {numberOfCorrectAnswers}:</div>}
			</div>
			
			{image && <div className="TaskIntro-image" />}
		</div>
	);
};

TaskIntro.propTypes = {
	showNumberOfAnswersToSelect: PropTypes.bool,
	numberOfCorrectAnswers: PropTypes.number,
	text: PropTypes.string,
	image: PropTypes.string,
	files: PropTypes.array,
	schoolData: PropTypes.object,
	setPopupFileData: PropTypes.func,
	scenarioId: PropTypes.string.isRequired,
};

export default TaskIntro;
